import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import "bootstrap-icons/font/bootstrap-icons.css";
import './css/index.css';
import './css/menu.css';
import './css/product.css';
import { GoogleOAuthProvider } from "@react-oauth/google";


import ConfigProvider from './Contexts/ConfigContext';

async function loadConfig() {
  try {
    const res = await fetch('/config.json?v=' + Math.floor(Date.now() / 1000));
    if (!res.ok) return {};
    return await res.json();
  } catch (e) {
    return {};
  }
}

function injectAnalytics(cfg) {
  if (!cfg) return;
  // prefer top-level gtmId, fallback to thirdParty.gtmId or thirdParty.googleAnalyticsId
  const id = cfg.gtmId || (cfg.thirdParty && cfg.thirdParty.gtmId) || (cfg.thirdParty && cfg.thirdParty.googleAnalyticsId);
  if (!id) return;

  // If ID looks like a GTM container (starts with GTM-), inject GTM
  if (id.startsWith('GTM-')) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(id);
    document.head.appendChild(s);
    const nos = document.createElement('noscript');
    nos.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(id)}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    if (document.body) document.body.insertBefore(nos, document.body.firstChild);
    else window.addEventListener('DOMContentLoaded', function(){ document.body.insertBefore(nos, document.body.firstChild); });
    return;
  }

  // If ID looks like a GA4 Measurement ID (starts with G-), inject gtag.js (analytics)
  if (id.startsWith('G-')) {
    // gtag setup
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);} ;
    window.gtag = window.gtag || gtag;
    window.gtag('js', new Date());
    window.gtag('config', id);

    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id);
    document.head.appendChild(s);
    return;
  }

  // Unknown id format: attempt to inject as GTM
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(id);
  document.head.appendChild(s);
}

loadConfig().then(cfg => {
  window.APP_CONFIG = cfg || {};
  injectAnalytics(cfg);

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <GoogleOAuthProvider clientId={cfg?.Authentication?.Google?.ClientId}>
      <React.StrictMode>
        <ConfigProvider value={cfg}>
          <App />
        </ConfigProvider>
      </React.StrictMode>
    </GoogleOAuthProvider>
  );

  // report web vitals after boot
  reportWebVitals();
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
